import { createElement as el } from "@wordpress/element";
import LanguageList from "../LanguageList/LanguageList";
import LinkBox from "../LinkBox/LinkBox";
import Tab from "../../interfaces/iTab";
import AppConfig from "../../services/appConfig";
import "./tabs.css";

/**
 * @returns Switcher Tab Content.
 */
const getSwitcherTabContent = () => {
  return el(
    "div",
    {
      className: "wpglobus-switcher-tab wpglobus-switcher-tab-content",
    },
    el(
      "div",
      {
        className: "wpglobus-switcher-tab-content__switcher-box",
      },
      <LanguageList />
    ),
    <LinkBox />
  );
};

const OptionsTabContent = () => {
  const { reactVersion, buildStat = "" } = AppConfig();
  var outputStat = "";
  if ("none" === buildStat) {
    outputStat = "Stats file doesn't exist";
  } else {
    try {
      var stat = JSON.parse(buildStat);
      outputStat = JSON.stringify(stat, null, 2);
    } catch {
      outputStat = "Parsing error.";
    }
  }

  return el(
    "div",
    {
      className: "content-wrapper",
    },
    el(
      "div",
      {
        className: "content-react-version",
      },
      <>Current React version: {reactVersion}</>
    ),
    el(
      "div",
      {
        className: "content-build-stats component-tabs",
      },
      <>
        <div>Build stats:</div>
        <pre className="stats">{outputStat}</pre>
      </>
    )
  );
};

const getOptionsTabContent = () => {
  return el(
    "div",
    {
      className: "wpglobus-switcher-tab wpglobus-options-tab-content",
    },
    <OptionsTabContent />
  );
};

const Tabs: Tab[] = [
  {
    name: "switcher",
    title: "Languages",
    className:
      "wpglobus-panel-tab wpglobus-panel-tab-switcher edit-widget-sidebar__panel-tab",
    inDebugModeOnly: false,
    active: true,
    callback: getSwitcherTabContent,
  },
  {
    name: "options",
    title: "Stats",
    className:
      "wpglobus-panel-tab wpglobus-panel-tab-options edit-widget-sidebar__panel-tab",
    inDebugModeOnly: false,
    active: true,
    callback: getOptionsTabContent,
  },
];

export default Tabs;
